// extracted by mini-css-extract-plugin
export default {"ArticleItemSkeleton":"ArticleItemSkeleton_ArticleItemSkeleton__yKFbm","Loading":"ArticleItemSkeleton_Loading__-ZijZ","load":"ArticleItemSkeleton_load__Ga+wR"};